import React, { useState } from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import Tabs from 'ui/Tabs/Tabs';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import { IInstantBank, IBank, Category } from '../../Beneficiaries.model';
import BenFAB from './subtabs/FAB/BenFAB';
import BenOtherBank from './subtabs/OtherBank/BenOtherBank';
import BenBulkTransfer from './subtabs/BulkTransfer/BenBulkTransfer';

const tabsOptions = [{ label: 'First Atlantic Bank' }, { label: 'Other Bank' }, { label: 'Bulk Transfer' }];

interface ITransfersBen {
  instantBanks: IInstantBank[];
  nonInstantBanks: IBank[];
  changeInitialCategory: (value: Category) => void;
}

const TransfersBen = ({ instantBanks, nonInstantBanks, changeInitialCategory }: ITransfersBen) => {
  const [activeSubTab, setActiveSubTab] = useState<false | number>(0);

  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

  const handleOnChangeTab = (_event: React.ChangeEvent<unknown>, tabIndex: number) => {
    if (tabIndex === 0) {
      changeInitialCategory('FABTransfer');
    }
    if (tabIndex === 1) {
      changeInitialCategory('otherBankTransfer');
    }
    setActiveSubTab(tabIndex);
  };

  return (
    <>
      {downMdScreen && <MobileSubtitle>Select category</MobileSubtitle>}
      <Tabs
        value={activeSubTab}
        options={tabsOptions}
        onChange={handleOnChangeTab}
        theme={downMdScreen ? 'primary' : 'secondary'}
        disableVertical
        scrollButtons="auto"
      />
      {activeSubTab === 0 && <BenFAB />}
      {activeSubTab === 1 && (
        <BenOtherBank instantBanks={instantBanks} nonInstantBanks={nonInstantBanks} />
      )}
      {activeSubTab === 2 && (
        <BenBulkTransfer instantBanks={instantBanks} nonInstantBanks={nonInstantBanks} />
      )}
    </>
  );
};

export default TransfersBen;
